
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './services/auth.service';
import { UserRole } from './shared/user-roles';
import {PLAN_TYPES} from './shared/constants'

export const authGuard: CanActivateFn = (route, state) => {
  const token = localStorage.getItem('authToken');
  const router = inject(Router);
  const authService = inject(AuthService);
  if (token && !authService.isTokenExpired(token)) {
    
    return true; // allow navigation
  } else {
    router.navigate(['/login']);
    return false; // block navigation
  }
};

export const hasAccessGuard: CanActivateFn = (route, state) => {
  debugger
  const authService = inject(AuthService);
  const hasAccess = authService.hasEditorOrAdminAccess();
  const isProductOwner = authService.isProductOwnerAccess();
  const planType  = authService.getCompanyPlan();
  const PlanStatus  = authService.getCompanyPlanStatus();
  const router = inject(Router);
  const requiredPermission = route.data['permission'] as string;
  
  if(planType == PLAN_TYPES.BASIC && (state.url == "/roles" || state.url == "/user")) //hide user/roles for Basic Plan
    return false;

  if (authService.hasPermission(requiredPermission) || isProductOwner) {
    return true;
  } else {
    router.navigate(['/unauthorized']);
    return false;
  }
};

export const hasProductOwnerGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const hasAccess = authService.isProductOwnerAccess();
  const router = inject(Router);
  
  
  if (hasAccess) {
    return true;
  } else {
    router.navigate(['/unauthorized']);
    return false;
  }
};

export const hideItemForBasicPlanAccessGuard: CanActivateFn = (route, state) => {
  debugger
  const authService = inject(AuthService);
  const planType  = authService.getCompanyPlan();
  const PlanStatus  = authService.getCompanyPlanStatus();
  const router = inject(Router);
  
  
  if(planType != PLAN_TYPES.ENTERPRISE && (state.url == "/sop-pending-approval")) //hide user/roles for Basic Plan
    return false;

    return true;
};